import match from 'pyonkoro.match';
import curry from 'lodash/curry';
/**
 *
 * @param rules[] = { predicate: value: any => boolean, message: string }[]
 * @param values = any
 */
const validator = curry((rules = [], values) => {
	const failResult = message => ({ message, result: false });
	const cases = rules.map(([predicate, message]) => {
		return [predicate, () => failResult(message)];
	});
	return match(cases, { result: true }, values);
}, 2);

export default validator;
